export const APP_ACTIONS = {
  NAVIGATE: "NAVIGATE",
  OPEN_BALL_PORTAL: "OPEN_BALL_PORTAL",
  SHOW_CONTACT: "SHOW_CONTACT",
  HIDE_CONTACT: "HIDE_CONTACT",
  MEET_JOZ_FLEX: "MEET_JOZ_FLEX",
  MEET_JOZ_DISCOVER: "MEET_JOZ_DISCOVER",
  MEET_JOZ_SKILLS: "MEET_JOZ_SKILLS",
  MEET_JOZ_BACK: "MEET_JOZ_BACK",
  MEET_JOZ_BACK1: "MEET_JOZ_BACK1",
};
